import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, renderSlot as _renderSlot, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "min-h-screen bg-dark flex" }
const _hoisted_2 = { class: "h-16 flex items-center justify-between px-4 border-b border-gray-700" }
const _hoisted_3 = {
  key: 0,
  class: "h-8 w-auto",
  src: _imports_0,
  alt: "Search Plus"
}
const _hoisted_4 = {
  key: 1,
  class: "h-8 w-8",
  src: _imports_0,
  alt: "Search Plus"
}
const _hoisted_5 = { class: "px-2 pt-4 pb-2 border-b border-gray-700 org-switcher-container" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "flex items-center min-w-0 flex-1" }
const _hoisted_8 = ["title"]
const _hoisted_9 = {
  key: 1,
  class: "absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-150 whitespace-nowrap z-50"
}
const _hoisted_10 = {
  key: 0,
  class: "absolute z-50 mt-1 w-full bg-dark-secondary border border-gray-700 rounded-md shadow-lg max-h-60 overflow-auto"
}
const _hoisted_11 = { class: "py-1" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "truncate" }
const _hoisted_14 = {
  key: 0,
  class: "w-4 h-4 ml-2 text-primary flex-shrink-0",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}
const _hoisted_15 = {
  key: 0,
  class: "px-3 py-2 text-sm text-gray-500"
}
const _hoisted_16 = {
  key: 1,
  class: "px-3 py-2 text-sm text-gray-500"
}
const _hoisted_17 = { class: "border-t border-gray-700 mt-1 pt-1 space-y-1" }
const _hoisted_18 = { class: "mt-4 px-2 space-y-1" }
const _hoisted_19 = {
  key: 0,
  class: "absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-150 whitespace-nowrap"
}
const _hoisted_20 = { class: "absolute bottom-[68px] w-full" }
const _hoisted_21 = {
  key: 0,
  class: "whitespace-nowrap"
}
const _hoisted_22 = {
  key: 1,
  class: "h-2 w-2 rounded-full bg-green-500 ring-2 ring-green-500 ring-opacity-50 animate-pulse ml-2"
}
const _hoisted_23 = {
  key: 2,
  class: "absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-150 whitespace-nowrap"
}
const _hoisted_24 = {
  key: 0,
  class: "bg-gray-800/40 backdrop-blur-sm border-b border-gray-700/50"
}
const _hoisted_25 = { class: "absolute bottom-0 w-full px-2 py-4" }
const _hoisted_26 = {
  key: 0,
  class: "absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded-md opacity-0 group-hover:opacity-100 transition-opacity duration-150 whitespace-nowrap"
}
const _hoisted_27 = { class: "sm:hidden fixed top-0 left-0 z-50 m-4" }
const _hoisted_28 = {
  key: 0,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_29 = {
  key: 1,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_30 = { class: "py-6" }
const _hoisted_31 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_32 = { class: "flex items-center justify-center min-h-screen px-4 py-4" }
const _hoisted_33 = { class: "bg-dark-secondary px-4 pt-5 pb-4 sm:p-6" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "p-3 bg-red-500/10 border border-red-500/20 rounded-md"
}
const _hoisted_37 = { class: "text-sm text-red-400" }
const _hoisted_38 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "flex items-center justify-center min-h-screen px-4 py-4" }
const _hoisted_42 = { class: "bg-dark-secondary px-4 pt-5 pb-4 sm:p-6" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "p-3 bg-red-500/10 border border-red-500/20 rounded-md"
}
const _hoisted_45 = { class: "text-sm text-red-400" }
const _hoisted_46 = { class: "flex justify-end gap-3 pt-4" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = ["disabled"]

import { ref, defineComponent, h, onMounted, onUnmounted, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { useUserStore } from '@/stores/user'
import { useOrgStore } from '@/stores/org'
import { functions } from '@/config/firebase'
import { httpsCallable } from 'firebase/functions'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {

const router = useRouter()
const authStore = useAuthStore()
const userStore = useUserStore()
const orgStore = useOrgStore()
const isMobileMenuOpen = ref(false)
const isCollapsed = ref(false)
const isReleaseNotesOpen = ref(false)
const isOrgDropdownOpen = ref(false)
const isJoinOrgModalOpen = ref(false)
const isCreateOrgModalOpen = ref(false)
const isJoiningOrg = ref(false)
const isCreatingOrg = ref(false)
const joinOrgError = ref<string | null>(null)
const createOrgError = ref<string | null>(null)
const joinOrgForm = ref({
  orgId: '',
  shareCode: ''
})
const createOrgForm = ref({
  orgName: ''
})
const hasUnreadUpdates = ref(true) // Set to true to show the notification dot

// Watch for release notes being opened while sidebar is collapsed
watch(isReleaseNotesOpen, (newValue) => {
  if (newValue && isCollapsed.value) {
    isCollapsed.value = false
  }
})

// Close release notes when sidebar is collapsed
watch(isCollapsed, (newValue) => {
  if (newValue && isReleaseNotesOpen.value) {
    isReleaseNotesOpen.value = false
  }
  if (newValue && isOrgDropdownOpen.value) {
    isOrgDropdownOpen.value = false
  }
})

// Close org dropdown when clicking outside
const handleClickOutside = (event: MouseEvent) => {
  const target = event.target as HTMLElement
  if (!target.closest('.org-switcher-container')) {
    isOrgDropdownOpen.value = false
  }
}

// Start listening to user document changes
onMounted(() => {
  userStore.startListening()
  orgStore.watchOrgData()
  orgStore.fetchUserOrgs()
  document.addEventListener('click', handleClickOutside)
})

// Clean up listener when component unmounts
onUnmounted(() => {
  userStore.stopListening()
  orgStore.cleanup()
  document.removeEventListener('click', handleClickOutside)
})

const handleSwitchOrg = async (orgId: string) => {
  if (orgId === orgStore.orgData?.id) {
    isOrgDropdownOpen.value = false
    return
  }

  try {
    await orgStore.switchOrg(orgId)
    isOrgDropdownOpen.value = false
    // Refresh the page to ensure all stores update with new org context
    window.location.reload()
  } catch (error) {
    console.error('Error switching org:', error)
  }
}

const openJoinOrgModal = () => {
  isOrgDropdownOpen.value = false
  isJoinOrgModalOpen.value = true
  joinOrgError.value = null
  joinOrgForm.value = { orgId: '', shareCode: '' }
}

const closeJoinOrgModal = () => {
  isJoinOrgModalOpen.value = false
  joinOrgError.value = null
  joinOrgForm.value = { orgId: '', shareCode: '' }
}

const handleJoinOrg = async () => {
  if (!joinOrgForm.value.orgId || !joinOrgForm.value.shareCode) {
    joinOrgError.value = 'Please enter both organization ID and share code'
    return
  }

  isJoiningOrg.value = true
  joinOrgError.value = null

  try {
    const joinOrgFn = httpsCallable(functions, 'joinExistingOrg')
    const result = await joinOrgFn({
      org_id: joinOrgForm.value.orgId.trim(),
      share_code: joinOrgForm.value.shareCode.trim()
    })
    const data = result.data as { success: boolean; message?: string }

    if (!data.success) {
      throw new Error(data.message || 'Failed to join organization')
    }

    // Refresh user orgs list
    await orgStore.fetchUserOrgs()
    
    // Close modal and reset form
    closeJoinOrgModal()
    
    // Optionally switch to the newly joined org
    await orgStore.switchOrg(joinOrgForm.value.orgId.trim())
    
    // Refresh the page to ensure all stores update with new org context
    window.location.reload()
  } catch (err: any) {
    joinOrgError.value = err.message || 'Failed to join organization. Please check your organization ID and share code.'
    console.error('Error joining org:', err)
  } finally {
    isJoiningOrg.value = false
  }
}

const openCreateOrgModal = () => {
  isOrgDropdownOpen.value = false
  isCreateOrgModalOpen.value = true
  createOrgError.value = null
  createOrgForm.value = { orgName: '' }
}

const closeCreateOrgModal = () => {
  isCreateOrgModalOpen.value = false
  createOrgError.value = null
  createOrgForm.value = { orgName: '' }
}

const handleCreateOrg = async () => {
  if (!createOrgForm.value.orgName || !createOrgForm.value.orgName.trim()) {
    createOrgError.value = 'Please enter an organisation name'
    return
  }

  isCreatingOrg.value = true
  createOrgError.value = null

  try {
    const createOrgFn = httpsCallable(functions, 'createOrg')
    const result = await createOrgFn({
      org_name: createOrgForm.value.orgName.trim()
    })
    const data = result.data as { success: boolean; org_id?: string; message?: string }

    if (!data.success) {
      throw new Error(data.message || 'Failed to create organization')
    }

    // Refresh user orgs list
    await orgStore.fetchUserOrgs()
    
    // Close modal and reset form
    closeCreateOrgModal()
    
    // Switch to the newly created org
    if (data.org_id) {
      await orgStore.switchOrg(data.org_id)
    }
    
    // Refresh the page to ensure all stores update with new org context
    window.location.reload()
  } catch (err: any) {
    createOrgError.value = err.message || 'Failed to create organization. Please try again.'
    console.error('Error creating org:', err)
  } finally {
    isCreatingOrg.value = false
  }
}

const DashboardIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6'
    })
  ])
})

const AnalyticsIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z'
    })
  ])
})

const ProductsIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13'
    })
  ])
})

const WidgetIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M4 5a1 1 0 011-1h14a1 1 0 011 1v2a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM4 13a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H5a1 1 0 01-1-1v-6zM16 13a1 1 0 011-1h2a1 1 0 011 1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-6z'
    })
  ])
})

const SettingsIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z'
    }),
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z'
    })
  ])
})

const BusinessIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4'
    })
  ])
})

const PersonaliseIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M13 10V3L4 14h7v7l9-11h-7z'
    })
  ])
})

// Search icon component
const SearchIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
    })
  ])
})

const FAQIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
    })
  ])
})

// Test tube icon for Searches view
const ExperimentIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z'
    })
  ])
})

const CustomizeIcon = defineComponent({
  render: () => h('svg', {
    xmlns: 'http://www.w3.org/2000/svg',
    fill: 'none',
    viewBox: '0 0 24 24',
    stroke: 'currentColor',
    class: 'w-5 h-5'
  }, [
    h('path', {
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
      'stroke-width': '2',
      d: 'M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01'
    })
  ])
})

const navigation = [
  { name: 'Dashboard', href: '/', icon: DashboardIcon },
  { name: 'Analytics', href: '/analytics', icon: AnalyticsIcon },
  { name: 'My Business', href: '/my-business', icon: BusinessIcon },
  { name: 'Test Search', href: '/my-search', icon: ExperimentIcon },
  { name: 'Searches', href: '/searches', icon: SearchIcon },
  { name: 'Product FAQs', href: '/faqs', icon: FAQIcon },
  { name: 'Customize Search', href: '/search-customization', icon: CustomizeIcon },
  { name: 'Personalise', href: '/personalise', icon: PersonaliseIcon },
  { name: 'Integrations', href: '/search-settings', icon: ProductsIcon },
  { name: 'Settings & Billing', href: '/settings', icon: SettingsIcon }
]

const handleSignOut = async () => {
  try {
    await authStore.signOut()
    userStore.stopListening()
    isMobileMenuOpen.value = false
    router.push('/login')
  } catch (error) {
    console.error('Error signing out:', error)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(userStore).hasOrg)
      ? (_openBlock(), _createElementBlock("aside", {
          key: 0,
          class: _normalizeClass([
        'fixed inset-y-0 left-0 z-50 bg-dark-secondary border-r border-gray-700 transform transition-all duration-300 ease-in-out',
        isMobileMenuOpen.value ? 'translate-x-0' : '-translate-x-full sm:translate-x-0',
        isCollapsed.value ? 'w-16' : 'w-64'
      ])
        }, [
          _createElementVNode("div", _hoisted_2, [
            (!isCollapsed.value)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_openBlock(), _createElementBlock("img", _hoisted_4)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isCollapsed.value = !isCollapsed.value)),
              class: "hidden sm:flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-300 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary"
            }, [
              (_openBlock(), _createElementBlock("svg", {
                class: _normalizeClass(["h-4 w-4 transform transition-transform duration-300", { 'rotate-180': isCollapsed.value }]),
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, _cache[11] || (_cache[11] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M11 19l-7-7 7-7m8 14l-7-7 7-7"
                }, null, -1)
              ]), 2))
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isOrgDropdownOpen.value = !isOrgDropdownOpen.value)),
                class: "w-full flex items-center justify-between px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:bg-gray-700 transition-colors duration-150 group"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  (_openBlock(), _createElementBlock("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    class: _normalizeClass(["w-5 h-5 mr-2 flex-shrink-0", { 'mr-0': isCollapsed.value }]),
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor"
                  }, _cache[12] || (_cache[12] = [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                    }, null, -1)
                  ]), 2)),
                  (!isCollapsed.value)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "truncate text-left",
                        title: (_unref(orgStore).orgData as any)?.org_name || _unref(orgStore).orgData?.name || _unref(orgStore).orgData?.id || 'Organization'
                      }, _toDisplayString((_unref(orgStore).orgData as any)?.org_name || _unref(orgStore).orgData?.name || _unref(orgStore).orgData?.id || 'Organization'), 9, _hoisted_8))
                    : _createCommentVNode("", true)
                ]),
                (!isCollapsed.value)
                  ? (_openBlock(), _createElementBlock("svg", {
                      key: 0,
                      class: _normalizeClass(["w-4 h-4 ml-2 flex-shrink-0 transition-transform duration-200", { 'rotate-180': isOrgDropdownOpen.value }]),
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor"
                    }, _cache[13] || (_cache[13] = [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 9l-7 7-7-7"
                      }, null, -1)
                    ]), 2))
                  : _createCommentVNode("", true),
                (isCollapsed.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString((_unref(orgStore).orgData as any)?.org_name || _unref(orgStore).orgData?.name || _unref(orgStore).orgData?.id || 'Organization'), 1))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_Transition, {
                "enter-active-class": "transition ease-out duration-100",
                "enter-from-class": "opacity-0 scale-95",
                "enter-to-class": "opacity-100 scale-100",
                "leave-active-class": "transition ease-in duration-75",
                "leave-from-class": "opacity-100 scale-100",
                "leave-to-class": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  (isOrgDropdownOpen.value && !isCollapsed.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgStore).userOrgs, (userOrg) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: userOrg.org_id,
                              onClick: ($event: any) => (handleSwitchOrg(userOrg.org_id)),
                              class: _normalizeClass(["px-3 py-2 text-sm text-gray-300 hover:bg-gray-700 cursor-pointer flex items-center justify-between", {
                    'bg-gray-700/50': userOrg.org_id === _unref(orgStore).orgData?.id
                  }])
                            }, [
                              _createElementVNode("span", _hoisted_13, _toDisplayString(userOrg.org_name), 1),
                              (userOrg.org_id === _unref(orgStore).orgData?.id)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _cache[14] || (_cache[14] = [
                                    _createElementVNode("path", {
                                      "fill-rule": "evenodd",
                                      d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                                      "clip-rule": "evenodd"
                                    }, null, -1)
                                  ])))
                                : _createCommentVNode("", true)
                            ], 10, _hoisted_12))
                          }), 128)),
                          (_unref(orgStore).userOrgs.length === 0 && !_unref(orgStore).loadingOrgs)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, " No organizations "))
                            : _createCommentVNode("", true),
                          (_unref(orgStore).loadingOrgs)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Loading... "))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("button", {
                              onClick: _withModifiers(openCreateOrgModal, ["stop"]),
                              class: "w-full px-3 py-2 text-sm text-white hover:bg-gray-700 cursor-pointer flex items-center gap-2"
                            }, _cache[15] || (_cache[15] = [
                              _createElementVNode("svg", {
                                class: "w-4 h-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 4v16m8-8H4"
                                })
                              ], -1),
                              _createElementVNode("span", null, "Create organisation", -1)
                            ])),
                            _createElementVNode("button", {
                              onClick: _withModifiers(openJoinOrgModal, ["stop"]),
                              class: "w-full px-3 py-2 text-sm text-white hover:bg-gray-700 cursor-pointer flex items-center gap-2"
                            }, _cache[16] || (_cache[16] = [
                              _createElementVNode("svg", {
                                class: "w-4 h-4",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z"
                                })
                              ], -1),
                              _createElementVNode("span", null, "Join organisation", -1)
                            ]))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("nav", _hoisted_18, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navigation, (item) => {
              return _createVNode(_component_router_link, {
                key: item.name,
                to: item.href,
                class: _normalizeClass(["flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-150 group", [
            _ctx.$route.path === item.href
              ? 'bg-gray-700'
              : 'text-gray-400 hover:bg-gray-700 hover:text-gray-300'
          ]]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isMobileMenuOpen.value = false))
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon), {
                    class: _normalizeClass(["w-5 h-5", { 'mr-3': !isCollapsed.value }])
                  }, null, 8, ["class"])),
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'opacity-0 w-0 overflow-hidden': isCollapsed.value })
                  }, _toDisplayString(item.name), 3),
                  (isCollapsed.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(item.name), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["to", "class"])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isReleaseNotesOpen.value = !isReleaseNotesOpen.value)),
              class: _normalizeClass(["w-full flex items-center px-4 py-3 text-sm font-medium border-t border-b border-gray-700/50 text-gray-400 hover:bg-gray-700/50 hover:text-gray-300 transition-all duration-200 group relative", { 'bg-gray-700/50': isReleaseNotesOpen.value }])
            }, [
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["w-5 h-5", { 'mr-3': !isCollapsed.value }]),
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, _cache[17] || (_cache[17] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                }, null, -1)
              ]), 2)),
              (!isCollapsed.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, " What's New "))
                : _createCommentVNode("", true),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex-1" }, null, -1)),
              (hasUnreadUpdates.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22))
                : _createCommentVNode("", true),
              (isCollapsed.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, " What's New "))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode(_Transition, {
              "enter-active-class": "transition-all duration-300 ease-out",
              "leave-active-class": "transition-all duration-200 ease-in",
              "enter-from-class": "opacity-0 -translate-y-2",
              "enter-to-class": "opacity-100 translate-y-0",
              "leave-from-class": "opacity-100 translate-y-0",
              "leave-to-class": "opacity-0 -translate-y-2"
            }, {
              default: _withCtx(() => [
                (isReleaseNotesOpen.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[19] || (_cache[19] = [
                      _createElementVNode("div", { class: "py-3 px-4 space-y-4 text-sm" }, [
                        _createElementVNode("div", { class: "relative space-y-4" }, [
                          _createElementVNode("div", { class: "relative pl-4 group" }, [
                            _createElementVNode("div", { class: "absolute left-0 top-[9px] flex items-center justify-center" }, [
                              _createElementVNode("div", { class: "h-2 w-2 rounded-full bg-primary group-hover:scale-150 transition-transform duration-300" }),
                              _createElementVNode("div", { class: "absolute h-[calc(100%+16px)] w-[1px] bg-gray-700/50 top-2 left-[3px]" })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "flex items-center gap-2 text-primary" }, [
                                _createElementVNode("span", { class: "font-medium" }, "v1.4.0"),
                                _createElementVNode("span", { class: "text-[11px] text-gray-500" }, "Sept 16, 2025"),
                                _createElementVNode("span", { class: "px-1.5 py-0.5 text-[10px] font-medium bg-primary/10 text-primary rounded-full" }, "Latest")
                              ]),
                              _createElementVNode("ul", { class: "mt-1 space-y-1 text-gray-400 text-xs" }, [
                                _createElementVNode("li", { class: "flex items-center gap-1.5 group/item hover:text-gray-300 transition-colors" }, [
                                  _createElementVNode("span", { class: "h-0.5 w-0.5 rounded-full bg-primary/50 group-hover/item:bg-primary transition-colors" }),
                                  _createElementVNode("span", null, "Enhanced AI insights with improved accuracy and data reliability")
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", { class: "relative pl-4 group" }, [
                            _createElementVNode("div", { class: "absolute left-0 top-[9px] flex items-center justify-center" }, [
                              _createElementVNode("div", { class: "h-2 w-2 rounded-full bg-gray-600 group-hover:scale-150 transition-transform duration-300" }),
                              _createElementVNode("div", { class: "absolute h-[calc(100%+16px)] w-[1px] bg-gray-700/50 top-2 left-[3px]" })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "flex items-center gap-2 text-gray-400" }, [
                                _createElementVNode("span", { class: "font-medium" }, "v1.3.0"),
                                _createElementVNode("span", { class: "text-[11px] text-gray-500" }, "Sept 15, 2025")
                              ]),
                              _createElementVNode("ul", { class: "mt-1 space-y-1 text-gray-500 text-xs" }, [
                                _createElementVNode("li", { class: "flex items-center gap-1.5 group/item hover:text-gray-400 transition-colors" }, [
                                  _createElementVNode("span", { class: "h-0.5 w-0.5 rounded-full bg-gray-600 group-hover/item:bg-gray-500 transition-colors" }),
                                  _createElementVNode("span", null, "Improved Shopify product sync with draft/archived status")
                                ]),
                                _createElementVNode("li", { class: "flex items-center gap-1.5 group/item hover:text-gray-400 transition-colors" }, [
                                  _createElementVNode("span", { class: "h-0.5 w-0.5 rounded-full bg-gray-600 group-hover/item:bg-gray-500 transition-colors" }),
                                  _createElementVNode("span", null, "Added visual indicators for product status")
                                ]),
                                _createElementVNode("li", { class: "flex items-center gap-1.5 group/item hover:text-gray-400 transition-colors" }, [
                                  _createElementVNode("span", { class: "h-0.5 w-0.5 rounded-full bg-gray-600 group-hover/item:bg-gray-500 transition-colors" }),
                                  _createElementVNode("span", null, "Enhanced product management with helpful tooltips")
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("div", { class: "relative pl-4 group" }, [
                            _createElementVNode("div", { class: "absolute left-0 top-[9px] flex items-center justify-center" }, [
                              _createElementVNode("div", { class: "h-2 w-2 rounded-full bg-gray-600 group-hover:scale-150 transition-transform duration-300" })
                            ]),
                            _createElementVNode("div", null, [
                              _createElementVNode("div", { class: "flex items-center gap-2 text-gray-400" }, [
                                _createElementVNode("span", { class: "font-medium" }, "v1.2.0"),
                                _createElementVNode("span", { class: "text-[11px] text-gray-500" }, "Sept 4, 2025")
                              ]),
                              _createElementVNode("ul", { class: "mt-1 space-y-1 text-gray-500 text-xs" }, [
                                _createElementVNode("li", { class: "flex items-center gap-1.5 group/item hover:text-gray-400 transition-colors" }, [
                                  _createElementVNode("span", { class: "h-0.5 w-0.5 rounded-full bg-gray-600 group-hover/item:bg-gray-500 transition-colors" }),
                                  _createElementVNode("span", null, "Added spam detection for searches")
                                ]),
                                _createElementVNode("li", { class: "flex items-center gap-1.5 group/item hover:text-gray-400 transition-colors" }, [
                                  _createElementVNode("span", { class: "h-0.5 w-0.5 rounded-full bg-gray-600 group-hover/item:bg-gray-500 transition-colors" }),
                                  _createElementVNode("span", null, "Improved search analytics")
                                ]),
                                _createElementVNode("li", { class: "flex items-center gap-1.5 group/item hover:text-gray-400 transition-colors" }, [
                                  _createElementVNode("span", { class: "h-0.5 w-0.5 rounded-full bg-gray-600 group-hover/item:bg-gray-500 transition-colors" }),
                                  _createElementVNode("span", null, "New customization options")
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], -1)
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              onClick: handleSignOut,
              class: "w-full flex items-center px-3 py-2 rounded-md text-sm font-medium text-gray-400 hover:bg-gray-700 hover:text-gray-300 transition-colors duration-150 group"
            }, [
              (_openBlock(), _createElementBlock("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: _normalizeClass(["w-5 h-5", { 'mr-3': !isCollapsed.value }]),
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, _cache[20] || (_cache[20] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                }, null, -1)
              ]), 2)),
              _createElementVNode("span", {
                class: _normalizeClass({ 'opacity-0 w-0 overflow-hidden': isCollapsed.value })
              }, " Sign Out ", 2),
              (isCollapsed.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, " Sign Out "))
                : _createCommentVNode("", true)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (isMobileMenuOpen.value = !isMobileMenuOpen.value)),
        type: "button",
        class: "inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-300 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary bg-dark-secondary"
      }, [
        _cache[23] || (_cache[23] = _createElementVNode("span", { class: "sr-only" }, "Open main menu", -1)),
        (!isMobileMenuOpen.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_28, _cache[21] || (_cache[21] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 6h16M4 12h16M4 18h16"
              }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("svg", _hoisted_29, _cache[22] || (_cache[22] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M6 18L18 6M6 6l12 12"
              }, null, -1)
            ])))
      ])
    ]),
    (isMobileMenuOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed inset-0 bg-black bg-opacity-50 sm:hidden z-40",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (isMobileMenuOpen.value = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["flex-1 transition-all duration-300 ease-in-out", { 'sm:ml-64': !isCollapsed.value, 'sm:ml-16': isCollapsed.value }])
    }, [
      _createElementVNode("main", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ], 2),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-150",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (isJoinOrgModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[9999] overflow-y-auto",
              onClick: _withModifiers(closeJoinOrgModal, ["self"])
            }, [
              _createElementVNode("div", {
                class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity",
                onClick: closeJoinOrgModal
              }),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", {
                  class: "relative bg-dark-secondary rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full max-w-lg",
                  onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
                      _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-100" }, "Join Organisation", -1)),
                      _createElementVNode("button", {
                        onClick: closeJoinOrgModal,
                        class: "text-gray-400 hover:text-gray-300"
                      }, _cache[24] || (_cache[24] = [
                        _createElementVNode("svg", {
                          class: "w-6 h-6",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))
                    ]),
                    _createElementVNode("form", {
                      onSubmit: _withModifiers(handleJoinOrg, ["prevent"]),
                      class: "space-y-4"
                    }, [
                      _createElementVNode("div", null, [
                        _cache[26] || (_cache[26] = _createElementVNode("label", {
                          for: "org-id",
                          class: "block text-sm font-medium text-gray-300 mb-1"
                        }, " Organization ID ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "org-id",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((joinOrgForm.value.orgId) = $event)),
                          type: "text",
                          required: "",
                          class: "w-full px-3 py-2 bg-dark border border-gray-700 rounded-md text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
                          placeholder: "Enter organization ID",
                          disabled: isJoiningOrg.value
                        }, null, 8, _hoisted_34), [
                          [_vModelText, joinOrgForm.value.orgId]
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500" }, "Ask your team admin for this ID", -1))
                      ]),
                      _createElementVNode("div", null, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", {
                          for: "share-code",
                          class: "block text-sm font-medium text-gray-300 mb-1"
                        }, " Share Code ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "share-code",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((joinOrgForm.value.shareCode) = $event)),
                          type: "text",
                          required: "",
                          class: "w-full px-3 py-2 bg-dark border border-gray-700 rounded-md text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
                          placeholder: "Enter share code",
                          disabled: isJoiningOrg.value
                        }, null, 8, _hoisted_35), [
                          [_vModelText, joinOrgForm.value.shareCode]
                        ]),
                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500" }, "Ask your team admin for the share code", -1))
                      ]),
                      (joinOrgError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("p", _hoisted_37, _toDisplayString(joinOrgError.value), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: closeJoinOrgModal,
                          class: "px-4 py-2 text-sm font-medium text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-md transition-colors",
                          disabled: isJoiningOrg.value
                        }, " Cancel ", 8, _hoisted_39),
                        _createElementVNode("button", {
                          type: "submit",
                          class: "px-4 py-2 text-sm font-medium text-white bg-primary hover:bg-primary/90 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                          disabled: isJoiningOrg.value
                        }, _toDisplayString(isJoiningOrg.value ? 'Joining...' : 'Join Organisation'), 9, _hoisted_40)
                      ])
                    ], 32)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      "enter-active-class": "transition ease-out duration-200",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-active-class": "transition ease-in duration-150",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (isCreateOrgModalOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-[9999] overflow-y-auto",
              onClick: _withModifiers(closeCreateOrgModal, ["self"])
            }, [
              _createElementVNode("div", {
                class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity",
                onClick: closeCreateOrgModal
              }),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", {
                  class: "relative bg-dark-secondary rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full max-w-lg",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_42, [
                    _createElementVNode("div", { class: "flex items-center justify-between mb-4" }, [
                      _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "text-lg font-medium text-gray-100" }, "Create Organisation", -1)),
                      _createElementVNode("button", {
                        onClick: closeCreateOrgModal,
                        class: "text-gray-400 hover:text-gray-300"
                      }, _cache[30] || (_cache[30] = [
                        _createElementVNode("svg", {
                          class: "w-6 h-6",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))
                    ]),
                    _createElementVNode("form", {
                      onSubmit: _withModifiers(handleCreateOrg, ["prevent"]),
                      class: "space-y-4"
                    }, [
                      _createElementVNode("div", null, [
                        _cache[32] || (_cache[32] = _createElementVNode("label", {
                          for: "org-name",
                          class: "block text-sm font-medium text-gray-300 mb-1"
                        }, " Organisation Name ", -1)),
                        _withDirectives(_createElementVNode("input", {
                          id: "org-name",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((createOrgForm.value.orgName) = $event)),
                          type: "text",
                          required: "",
                          class: "w-full px-3 py-2 bg-dark border border-gray-700 rounded-md text-gray-100 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent",
                          placeholder: "Enter organisation name",
                          disabled: isCreatingOrg.value
                        }, null, 8, _hoisted_43), [
                          [_vModelText, createOrgForm.value.orgName]
                        ]),
                        _cache[33] || (_cache[33] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500" }, "Choose a name for your organisation", -1))
                      ]),
                      (createOrgError.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("p", _hoisted_45, _toDisplayString(createOrgError.value), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("button", {
                          type: "button",
                          onClick: closeCreateOrgModal,
                          class: "px-4 py-2 text-sm font-medium text-gray-300 bg-gray-700 hover:bg-gray-600 rounded-md transition-colors",
                          disabled: isCreatingOrg.value
                        }, " Cancel ", 8, _hoisted_47),
                        _createElementVNode("button", {
                          type: "submit",
                          class: "px-4 py-2 text-sm font-medium text-white bg-primary hover:bg-primary/90 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
                          disabled: isCreatingOrg.value
                        }, _toDisplayString(isCreatingOrg.value ? 'Creating...' : 'Create Organisation'), 9, _hoisted_48)
                      ])
                    ], 32)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})